import { NotificationType } from './NotificationsMenu.types';
import { isCommentLike } from './isCommentLike';

export const getActionHash = ({
  type,
  data,
  idAction,
}: {
  type?: NotificationType;
  data?: { actionType?: string };
  idAction?: string;
}) => {
  if (idAction) {
    if (isCommentLike({ type, data })) {
      return `comment-${idAction}`;
    }
    return `action-${idAction}`;
  }

  return '';
};
